<div class="page-container">
  <div class="page-header-container form-page-header-container">
    <sxw-bread-crumb [items]="breadCrumb()" class="mb-20" />
    <app-page-header
      [title]="'STOCK_TYPE.TITLES.EDIT'"
      [cancelLink]="StockTypeRoutePaths.ROOT"
      [showSubmit]="true"
      [loading]="formElm.loading"
      (onSubmit)="formElm.submit()"
      [disableSubmit]="!formModel.formGroup().valid"
      cancelLabel="COMMON.CANCEL_LABEL"
      submitLabel="STOCK_TYPE.ACTIONS.SUBMIT" />
  </div>

  <div class="page-content-container form-page-content-container">
    <sxw-form
      #formElm
      [formModel]="formModel"
      [mutationConfig]="mutationConfigType"
      [extraParamsValues]="{ id: stockType().id }"
      (onMutationComplete)="navigateToList()">
      <app-stock-type-form />
    </sxw-form>
  </div>
</div>
